<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Tahun" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Tahun"
                    label="Tahun"
                    type="number"
                    :error-messages="errors"
                    placeholder="Tahun"
                    v-model.number="form.Tahun"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Nama Sekolah" rules="required" #default="{ errors }">
                  <v-select
                    class="mb-3"
                    :items="list.sekolah.data"
                    name="KodeSekolah"
                    label="KodeSekolah"
                    :error-messages="errors"
                    placeholder="Nama Sekolah"
                    v-model="form.KodeSekolah"
                    :return-object="false"
                    hide-details="auto"
                    item-text="NamaSekolah"
                    item-value="KodeSekolah"
                    outlined
                    required
                    dense
                  ></v-select>
                </Validate>
                <v-text-field
                  class="mb-3"
                  v-model.number="form.SisaUang"
                  name="SisaUang"
                  type="number"
                  placeholder="0"
                  large
                  hide-no-data
                  outlined
                  required
                  dense
                ></v-text-field>
                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Tahun: 0,
      KodeSekolah: "",
      NamaSekolah: "",
      SisaUang: 0
    },
    list: {
      sekolah: {
        data: []
      }
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app
    })
  },
  methods: {
    async getSekolah() {
      this.$axios.get('/bosnas/listsekolah').
        then((res) => {
          this.list.sekolah.data = res.data.Data
          console.log(this.list.sekolah.data)
        }).catch((error) => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
    },
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      const selectedSekolah = this.list.sekolah.data.find((d) => d.KodeSekolah == this.form.KodeSekolah)
      this.form.NamaSekolah = selectedSekolah.NamaSekolah
      this.saving = true;
      this.$axios
        .post("/silpa", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/master/silpa");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Silpa" : "Silpa Baru";
    }
  },
  async mounted() {
    this.getSekolah()
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/silpa/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>